import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FiMenu,
  FiX,
  FiStar,
  FiUsers,
  FiAlertTriangle
} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b-4 border-brand-gold bg-brand-darkbg/95 shadow-lg backdrop-blur-md">
      <div
        className="misconduct-ticker overflow-hidden border-b border-brand-gold/30 bg-brand-navy text-white"
        aria-label="Important reporting information"
      >
        <div className="misconduct-ticker-track">
          <div className="misconduct-ticker-message">
            <SafeIcon icon={FiAlertTriangle} className="shrink-0 text-brand-gold" />
            <span>
              To report misconduct by a driving instructor, call Transport for NSW on{' '}
              <a
                href="tel:131500"
                className="font-bold text-brand-gold underline underline-offset-2 hover:text-white"
              >
                131 500
              </a>.
            </span>
          </div>
          <div className="misconduct-ticker-message" aria-hidden="true">
            <SafeIcon icon={FiAlertTriangle} className="shrink-0 text-brand-gold" />
            <span>
              To report misconduct by a driving instructor, call Transport for NSW on{' '}
              <a
                href="tel:131500"
                className="font-bold text-brand-gold underline underline-offset-2 hover:text-white"
                tabIndex="-1"
              >
                131 500
              </a>.
            </span>
          </div>
        </div>
      </div>

      <div className="container mx-auto flex items-center justify-between px-4 py-2 md:px-6">
        <Link to="/" className="z-50" onClick={closeMenu}>
          <Logo />
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          <Link
            to="/#instructors"
            className="flex items-center gap-2 font-semibold text-white transition-colors hover:text-brand-green"
          >
            <SafeIcon icon={FiUsers} className="text-brand-gold" />
            Instructors
          </Link>
          <Link
            to="/review"
            className="flex items-center gap-2 rounded-full border-2 border-white/10 px-4 py-2 font-semibold text-white transition-colors hover:border-brand-green/20 hover:text-brand-green"
          >
            <SafeIcon icon={FiStar} className="text-brand-gold" />
            Review Us
          </Link>
          <Link
            to="/booking"
            className="group relative overflow-hidden rounded-full bg-brand-gold px-6 py-2.5 font-display text-brand-navy shadow-md transition-all hover:bg-[#D4891A]"
          >
            <span className="relative z-10">Book Now</span>
            <span className="absolute inset-0 h-full w-full origin-left scale-x-0 bg-white/20 transition-transform duration-300 ease-out group-hover:scale-x-100" />
          </Link>
        </nav>

        <button
          type="button"
          className="z-50 rounded-md p-3 text-white md:hidden"
          onClick={() => setIsOpen((current) => !current)}
          aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isOpen}
        >
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute left-0 top-full w-full border-b-4 border-brand-gold bg-brand-surface shadow-xl md:hidden"
          >
            <div className="flex flex-col gap-4 px-4 py-6">
              <Link
                to="/#instructors"
                onClick={closeMenu}
                className="flex items-center justify-center gap-3 rounded-full border border-white/10 bg-white/5 py-3 font-display text-xl text-white"
              >
                <SafeIcon icon={FiUsers} className="text-brand-gold" />
                Instructors
              </Link>
              <Link
                to="/review"
                onClick={closeMenu}
                className="flex items-center justify-center gap-3 rounded-full border border-white/10 bg-white/5 py-3 font-display text-xl text-white"
              >
                <SafeIcon icon={FiStar} className="text-brand-gold" />
                Review Us
              </Link>
              <Link
                to="/booking"
                onClick={closeMenu}
                className="rounded-full bg-brand-gold py-4 text-center font-display text-xl text-brand-navy shadow-lg"
              >
                Book Now
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}